<template>
  <div class="news-card" @click.stop="goDetail(newsDetail.id)">
    <div class="img-wrapper">
      <img v-lazy="newsDetail.coverIcon" class="img lazy-img-fadein" />
    </div>

    <div class="footer">
      <div class="news-title ellipsis">{{ newsDetail.title }}</div>
      <div class="news-desc ellipsis">{{ newsDetail.description }}</div>
      <div class="news-date">{{ formatDate(newsDetail.createTime) }}</div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    newsDetail: {
      type: [Object],
      default: () => {}
    }
  },
  name: 'newsCard',

  data() {
    return {}
  },
  watch: {},
  mounted() {},
  methods: {
    // 跳转详情
    goDetail(id) {
      this.$router.push(`/news/${id}`)
    },
    // 时间转换
    formatDate(date) {
      return this.$funcs.dateFormat(date, 'YYYY-mm-dd HH:MM:SS')
    }
  }
}
</script>
<style lang="stylus" scoped>
.news-card
  margin-top:16px;
  width 100%
  // transition all 0.3s
  overflow hidden
  // margin-bottom 16px
  background $color-white
  box-shadow 0px 2px 6px 0px rgba(0,0,0,0.15)
  border-radius 8px;
  display flex
  &:hover
    cursor pointer
    box-shadow 0 6px 5px 5px $box-shadow1, 0 6px 8px 2px $box-shadow2
    // transition 0.3s all
    .news-title
      color $color-main
    .img
      // transform: scale(1.2)
  .img-wrapper
    width 160px
    height 90px
    overflow hidden
  .img
    object-fit cover
    width 100%
    height 100%
    border-radius 8px;
    // transition 0.3s all

  .footer
    width 100%
    height 82px
    position relative
  
  .news-title
    width calc(100% - 32px)
    // height 50px
    font-size 16px
    font-weight bold
    line-height 20px
    position absolute
    top 16px
    left 16px
    color $color-black-85
  .news-desc
    width calc(100% - 32px)
    // height 50px
    font-size 14px
    line-height 18px
    position absolute
    top 40px
    left 16px
    color $color-black-45

  .news-date
    position absolute
    bottom 2px
    right 12px
    font-size 12px
    font-weight bold
    color $color-black-25
</style>
